import donations from "./donations";

export default {
    donations
}